import { useContext } from "react";
import { GameState } from "../GameState";
import MainMenuButton from "./MainMenuButton";

const GameOver = () => {
  const state = useContext(GameState);

  return (
    <div className="gameover">
      <div className="gameover-title">GAME OVER</div>
      <div className="gameover-subtitle">The IRS has shut down all of your operations.</div>
      <div className="gameover-score">You laundered ${Math.floor(state.score).toLocaleString()}!</div>
      <div className="gameover-seized">The IRS seized ${Math.floor(state.seizedMoney).toLocaleString()}.</div>
      <MainMenuButton name="MAIN MENU" action={() => window.location.reload() } />
    </div>
  );
};

export default GameOver;
